export default __webpack_public_path__ + "static/media/HR.7508ddca.gif";